import axios from "axios";

export const SetLocationMy = {
  methods: {
    async SetMyLocationMethod() {
      console.log("hiiii");
      try {
        const response = await axios.post(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBrftCAqKGbs4qrzM1JL8_Sb8Kl7Dk5CLQ`
        );
        const { lat, lng } = response.data.location;

        let StartLocation = [lat, lng];
        let StartDate = null;
        StartDate = new Date().getTime();
        console.log("niranjan", StartDate);
        this.$store.commit("SET_COMPLETE_DATA", { StartDate, StartLocation });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
